/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetAnalysisInvoiceOfPaymentRequest200ResponseSupplier
 */
export interface GetAnalysisInvoiceOfPaymentRequest200ResponseSupplier {
    /**
     * 
     * @type {string}
     * @memberof GetAnalysisInvoiceOfPaymentRequest200ResponseSupplier
     */
    'partnerId': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAnalysisInvoiceOfPaymentRequest200ResponseSupplier
     */
    'name': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAnalysisInvoiceOfPaymentRequest200ResponseSupplier
     */
    'bankNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAnalysisInvoiceOfPaymentRequest200ResponseSupplier
     */
    'bankName': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAnalysisInvoiceOfPaymentRequest200ResponseSupplier
     */
    'branchNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAnalysisInvoiceOfPaymentRequest200ResponseSupplier
     */
    'branchName': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAnalysisInvoiceOfPaymentRequest200ResponseSupplier
     */
    'accountNumber': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetAnalysisInvoiceOfPaymentRequest200ResponseSupplier
     */
    'accountType': GetAnalysisInvoiceOfPaymentRequest200ResponseSupplierAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetAnalysisInvoiceOfPaymentRequest200ResponseSupplier
     */
    'companyName': string | null;
}

export const GetAnalysisInvoiceOfPaymentRequest200ResponseSupplierAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    thriftAccount: 'THRIFT_ACCOUNT',
    other: 'OTHER'
} as const;

export type GetAnalysisInvoiceOfPaymentRequest200ResponseSupplierAccountTypeEnum = typeof GetAnalysisInvoiceOfPaymentRequest200ResponseSupplierAccountTypeEnum[keyof typeof GetAnalysisInvoiceOfPaymentRequest200ResponseSupplierAccountTypeEnum];


